module.exports = {"stats":{"title":"Databases","count":"254321","descr":"Waiting for review"},"information":{"text":"Lorem ipsum dolor sit amet, consectetur adipisicing elit. Asperiores, vero."},"commerceStats":{"title":"LIFETIME SALES","count":"$16,942.00"}}


//////////////////
// WEBPACK FOOTER
// ./src/components/CleanComponents/InfoCard/data.json
// module id = 1285
// module chunks = 0